package link.erpango.quip

object QuipConstants {

    object DateFormat {

        const val utc = "UTC"
        const val backendUtcPattern1 = "YYYY-MM-dd'T'HH:mm:ss'Z'"
        const val utcPattern1 = "yyyy-MM-dd'T'HH:mm:ss'Z'"
        const val utcPattern2 = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
        const val utcPattern3 = "yyyy-MM-dd'T'HH:mm:ss.SSSSSS'Z'"
        const val utcPattern4 = "yyyy-MM-dd'T'HH:mm:ss.SSSSSS+HH:mm"
        const val noUtcPattern1 = "dd/MM/yyyy HH:mm:ss"
        const val noUtcPattern2 = "dd/MM/yyyy HH:mm"
        const val noUtcPattern3 = "d/M/yyyy HH:mm:ss"
        const val noUtcPattern4 = "d/M/yyyy HH:mm"
        const val noUtcPatternEnglishWithoutTime = "yyyy/MM/dd"
        const val noUtcPatternSpanishWithoutTime = "dd/MM/yyyy"
        const val noUtcPatternSpanishWithoutTimeWithDash = "dd-MM-yyyy"
        const val dateInsideLog = "dd HH:mm:ss"
        const val timePattern = "HH:mm:ss"
        const val simpleTimePattern = "HH:mm"
        const val simpleUtcPattern = "yyyy-MM-dd HH:mm:ss"

        val allFormats = listOf(
            utcPattern1,
            utcPattern2,
            utcPattern3,
            utcPattern4,
            noUtcPattern1,
            noUtcPattern2,
            noUtcPattern3,
            noUtcPattern4,
            noUtcPatternEnglishWithoutTime,
            noUtcPatternSpanishWithoutTime,
            noUtcPatternSpanishWithoutTimeWithDash,
            backendUtcPattern1,
            timePattern,
            simpleTimePattern,
            simpleUtcPattern,
            dateInsideLog
        )

    }

    object Notifications {
        const val TEST_CHANNEL = "test_channel"
        const val REMINDERS_CHANNEL = "reminders_channel"
    }
    object Firebase {
        object Messaging {
            const val TESTING_TOPIC = "testing_topic"
        }
        object RemoteConfig {
            const val REMOTE_CONFIG_KEY = "remote_config_key"
            val keyList = listOf(
                REMOTE_CONFIG_KEY
            )
        }
    }
    object Http {

        const val socketTimeout = 20000L
        const val connectionTimeout = 10000L // 10 segs
        const val requestTimeout = 20000L // 20 segs
        // Extracción con LLM: el backend puede tardar hasta 270 s (EXTRACTION_LLM_TOTAL_DEADLINE)
        // con el modelo local de razonamiento; gunicorn corta a los 300 s.
        const val extractionTimeout = 290000L // 290 segs
        const val deserializationError = 600

        // HTTP Headers vars
        object Headers {

            const val authorization = "Authorization"
            const val jwt = "Bearer"
            const val contentType = "Content-Type"
            const val accept = "Accept"
            const val userAgent = "User-Agent"
            const val contentTypeJson = "application/json"
            const val uuid = "uuid"
            const val xTimeZone = "X-TimeZone"
        }
    }

    object CommonFlags {
        object SystemInfo {
            const val debug = "DEBUG"
        }
        object Runtime {
            const val isInBackground = "IS_IN_BACKGROUND"
            const val isLocationServiceRunning = "IS_LOCATION_SERVICE_RUNNING"
        }
        object User {
            const val needToRefresh = "NEED_TO_REFRESH"
            const val isSessionExpired = "IS_SESSION_EXPIRED"
        }
    }

    object CommonValues {
        object Catalog {
            const val lastCatalogSync = "LAST_CATALOG_SYNC"
        }
        object Firebase {
            const val firebaseCloudMessagingToken = "FCM_TOKEN"
        }
        object NoteImport {
            // Consentimiento para enviar notas al LLM. La versión obliga a pedirlo de nuevo si
            // cambia el texto del consentimiento. Se borra al cerrar sesión.
            const val aiConsent = "NOTE_IMPORT_AI_CONSENT_V1"
        }
        object SystemInfo {
            const val appId = "SYSTEM_INFO_APP_ID"
            const val appName = "SYSTEM_INFO_APP_NAME"
            const val appVersionName = "SYSTEM_INFO_APP_VERSION_NAME"
            const val appVersionCode = "SYSTEM_INFO_APP_VERSION_CODE"
            const val userAgent = "SYSTEM_INFO_USER_AGENT"
            const val deviceId = "SYSTEM_INFO_DEVICE_ID"
            const val deviceModel = "SYSTEM_INFO_DEVICE_MODEL"
            const val deviceSO = "SYSTEM_INFO_DEVICE_SD"
            const val system = "SYSTEM_INFO_DEVICE_SYSTEM"
            const val mac = "SYSTEM_INFO_MAC"
            const val xTimeZone = "SYSTEM_INFO_XTIMEZONE"
        }
        object Generic {
            const val lastSwipeTime = "LAST_SWIPE_TIME"
            const val navigationSignal = "NAVIGATION_SIGNAL"
            const val navigationSignalOK = "NAVIGATION_SIGNAL_OK"
            const val navigationSignalKO = "NAVIGATION_SIGNAL_KO"
            // valor para almacenar el último versionCode para el q se ha migrado la base de datos
            const val lastDatabaseMigrationVersion = "LAST_DATABASE_MIGRATION_VERSION"
        }
        object DataBasePeriodicDelete {
            //Se multiplican los millis de un día por la cantidad de días que queramos como intervalo (max 24 antes de overflow)
            const val deleteIntervalMillis = Datetime.millisecondsInDay * 30
        }
    }

    object Datetime {
        const val millisecondsInDay: Long = 86400000 // 24 * 60 * 60 * 1000
    }

    object Units {
        const val count = "count"
        const val liters = "L"
    }

    object VehicleAttributes {
        val FuelTypes = listOf(
            "Gasolina 95",
            "Gasolina 98",
            "Diésel",
            "Diésel Premium",
            "GLP",
            "GNC",
            "Eléctrico",
            "Híbrido",
            "Híbrido Enchufable"
        )

        val EngineOilTypes = listOf(
            // Totalmente sintéticos — baja viscosidad en frío
            "0W-8", "0W-16", "0W-20", "0W-30", "0W-40",
            // Totalmente sintéticos — 5W
            "5W-20", "5W-30", "5W-40", "5W-50",
            // Semisintéticos / sintéticos — 10W
            "10W-30", "10W-40", "10W-50", "10W-60",
            // Semisintéticos / minerales — 15W
            "15W-40", "15W-50",
            // Minerales — alta viscosidad
            "20W-40", "20W-50",
            "25W-50", "25W-60",
            // Monogrados (motos clásicas, tractores)
            "SAE 30", "SAE 40", "SAE 50",
            // Motos 2 tiempos
            "2T"
        )

        val CylinderCounts = listOf(
            1, 2, 3, 4, 5, 6, 8, 10, 12, 16
        )

        val VehicleBrands = listOf(
            // Europeas
            "Abarth", "Alfa Romeo", "Aston Martin", "Audi", "Bentley", "BMW", "Bugatti",
            "Citroën", "Cupra", "Dacia", "DS", "Ferrari", "Fiat", "Ford", "Jaguar",
            "Lamborghini", "Lancia", "Land Rover", "Lotus", "Maserati", "McLaren",
            "Mercedes-Benz", "MINI", "Opel", "Peugeot", "Porsche", "Renault", "Rolls-Royce",
            "SEAT", "Škoda", "Smart", "Vauxhall", "Volkswagen", "Volvo",
            // Japonesas
            "Daihatsu", "Honda", "Infiniti", "Isuzu", "Lexus", "Mazda", "Mitsubishi",
            "Nissan", "Subaru", "Suzuki", "Toyota",
            // Coreanas
            "Genesis", "Hyundai", "Kia",
            // Americanas
            "Cadillac", "Chevrolet", "Chrysler", "Dodge", "Ford", "GMC", "Jeep",
            "Lincoln", "Ram", "Tesla",
            // Chinas
            "BYD", "Chery", "Great Wall", "Haval", "MG", "NIO", "Omoda", "Ora",
            // Motos
            "Aprilia", "Benelli", "Beta", "BMW Motorrad", "Ducati", "Gas Gas",
            "Harley-Davidson", "Honda", "Husqvarna", "Indian", "Kawasaki", "Keeway",
            "Kymco", "KTM", "Lifan", "Moto Guzzi", "Orcal", "Piaggio", "Rieju",
            "Royal Enfield", "Sherco", "SYM", "Suzuki", "Triumph",
            "Vespa", "Voge", "Yamaha", "Zontes"
        ).distinct().sorted()

        val VehicleModelsByBrand = mapOf(
            "Abarth" to listOf("124 Spider", "500", "595", "695"),
            "Alfa Romeo" to listOf("Giulia", "Giulietta", "MiTo", "Stelvio", "Tonale", "156", "159", "147", "166"),
            "Aston Martin" to listOf("DB11", "DB12", "DBX", "Vantage"),
            "Audi" to listOf(
                "A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8",
                "Q2", "Q3", "Q4 e-tron", "Q5", "Q7", "Q8",
                "TT", "R8", "e-tron", "e-tron GT", "RS3", "RS4", "RS5", "RS6", "RS7", "S3", "S4", "S5", "S6", "SQ5"
            ),
            "Bentley" to listOf("Bentayga", "Continental GT", "Flying Spur", "Mulsanne"),
            "BMW" to listOf(
                "Serie 1", "Serie 2", "Serie 3", "Serie 4", "Serie 5", "Serie 6", "Serie 7", "Serie 8",
                "X1", "X2", "X3", "X4", "X5", "X6", "X7",
                "Z4", "i3", "i4", "i7", "iX", "M2", "M3", "M4", "M5", "M8", "X5 M", "X6 M"
            ),
            "Bugatti" to listOf("Chiron", "Divo", "Veyron"),
            "Citroën" to listOf(
                // Actuales
                "Berlingo", "C3", "C3 Aircross", "C4", "C4 Cactus", "C5 Aircross", "C5 X",
                "ë-C3", "ë-C4", "ë-Berlingo", "ë-Spacetourer",
                "Jumper", "Jumpy", "Spacetourer",
                // Históricos
                "AX", "BX", "C1", "C2", "C5", "C6", "C8",
                "C-Crosser", "C-Elysée", "DS", "DS3", "DS4", "DS5",
                "Evasion", "Nemo", "Picasso", "Grand C4 Picasso", "C4 Picasso",
                "Saxo", "Visa", "Xantia", "XM", "Xsara", "Xsara Picasso",
                "ZX", "Relay", "Dispatch"
            ),
            "Cupra" to listOf("Ateca", "Born", "Formentor", "Leon", "Terramar"),
            "Dacia" to listOf("Duster", "Jogger", "Logan", "Sandero", "Spring", "Bigster"),
            "DS" to listOf("DS 3", "DS 4", "DS 7", "DS 9"),
            "Ferrari" to listOf("296 GTB", "488", "812", "F8", "GTC4Lusso", "Portofino", "Roma", "SF90"),
            "Fiat" to listOf(
                "124 Spider", "500", "500L", "500X", "Bravo", "Doblo", "Ducato",
                "Grande Punto", "Panda", "Punto", "Tipo", "Scudo"
            ),
            "Ford" to listOf(
                "B-Max", "C-Max", "EcoSport", "Edge", "Explorer", "F-150", "Fiesta",
                "Focus", "Fusion", "Galaxy", "Ka", "Kuga", "Mondeo", "Mustang",
                "Mustang Mach-E", "Puma", "Ranger", "S-Max", "Tourneo", "Transit"
            ),
            "Genesis" to listOf("G70", "G80", "G90", "GV70", "GV80"),
            "GMC" to listOf("Acadia", "Canyon", "Sierra", "Terrain", "Yukon"),
            "Haval" to listOf("F7", "H6", "H9", "Jolion"),
            "Honda" to listOf(
                "Accord", "CB 125", "CB 500", "CB 650", "CBR 125", "CBR 500", "CBR 600", "CBR 1000",
                "Civic", "CR-V", "CRF 300", "FR-V", "HR-V", "Jazz",
                "NC 750", "PCX", "Rebel", "SH", "X-ADV"
            ),
            "Hyundai" to listOf(
                // Actuales
                "Bayon", "Elantra", "i10", "i20", "i30", "i40", "IONIQ", "IONIQ 5", "IONIQ 6",
                "Kona", "Santa Fe", "Sonata", "Staria", "Tucson", "Venue",
                // Históricos
                "Accent", "Atos", "Azera", "Coupe", "Galloper", "Genesis Coupe", "Getz",
                "Grand Santa Fe", "H-1", "H1 Starex", "ix20", "ix35", "ix55",
                "Matrix", "Pony", "S-Coupe", "Terracan", "Trajet", "Veloster",
                "XG", "Grandeur"
            ),
            "Infiniti" to listOf("Q30", "Q50", "Q60", "QX30", "QX50", "QX70", "QX80"),
            "Jaguar" to listOf("E-Pace", "E-Type", "F-Pace", "F-Type", "I-Pace", "XE", "XF", "XJ"),
            "Jeep" to listOf("Cherokee", "Compass", "Gladiator", "Grand Cherokee", "Renegade", "Wrangler"),
            "Kawasaki" to listOf(
                "ER-6N", "ER-6F", "Ninja 300", "Ninja 400", "Ninja 650", "Ninja 1000",
                "Versys 650", "Versys 1000", "Z400", "Z650", "Z900", "Z1000"
            ),
            "Kia" to listOf(
                "Ceed", "EV6", "EV9", "Niro", "Picanto", "ProCeed", "Rio",
                "Sorento", "Soul", "Sportage", "Stinger", "Stonic", "XCeed"
            ),
            "KTM" to listOf(
                "Duke 125", "Duke 390", "Duke 690", "Duke 790", "Duke 890", "Duke 990",
                "Adventure 390", "Adventure 790", "Adventure 890", "Adventure 1290",
                "EXC 125", "EXC 250", "EXC 300", "SMC 690", "Super Duke 990", "Super Duke 1290"
            ),
            "Lamborghini" to listOf("Aventador", "Huracán", "Urus"),
            "Lancia" to listOf("Delta", "Thema", "Ypsilon"),
            "Land Rover" to listOf("Defender", "Discovery", "Discovery Sport", "Freelander", "Range Rover", "Range Rover Evoque", "Range Rover Sport", "Range Rover Velar"),
            "Lexus" to listOf("CT", "ES", "GS", "IS", "LC", "LS", "NX", "RC", "RX", "UX"),
            "Mazda" to listOf("2", "3", "5", "6", "CX-3", "CX-30", "CX-5", "CX-60", "MX-5", "MX-30"),
            "McLaren" to listOf("570S", "600LT", "720S", "765LT", "Artura", "GT"),
            "Mercedes-Benz" to listOf(
                "A-Class", "B-Class", "C-Class", "CLA", "CLS", "E-Class",
                "EQA", "EQB", "EQC", "EQE", "EQS",
                "G-Class", "GLA", "GLB", "GLC", "GLE", "GLS",
                "S-Class", "SL", "SLC", "Sprinter", "Vito",
                "AMG GT", "C 63", "E 63", "G 63", "S 63"
            ),
            "MG" to listOf("3", "4", "5", "ZS", "Marvel R", "HS", "RX5"),
            "MINI" to listOf("Cabrio", "Clubman", "Countryman", "Cooper", "Cooper S", "Electric", "Paceman"),
            "Mitsubishi" to listOf("ASX", "Colt", "Eclipse Cross", "Galant", "Grandis", "L200", "Lancer", "Outlander", "Pajero", "Space Star"),
            "Nissan" to listOf(
                "350Z", "370Z", "Ariya", "GT-R", "Juke", "Leaf", "Micra",
                "Murano", "Navara", "Note", "Pathfinder", "Pulsar", "Qashqai", "X-Trail"
            ),
            "Omoda" to listOf("5", "5 EV"),
            "Opel" to listOf(
                "Adam", "Agila", "Astra", "Cascada", "Corsa", "Crossland", "Grandland",
                "Insignia", "Meriva", "Mokka", "Movano", "Vivaro", "Zafira"
            ),
            "Peugeot" to listOf(
                // Actuales
                "208", "2008", "308", "3008", "408", "508", "5008",
                "e-208", "e-2008", "e-308", "e-3008",
                "Boxer", "Expert", "Traveller",
                // Históricos
                "104", "106", "107", "108",
                "205", "206", "206+", "207",
                "301", "304", "305", "306", "307",
                "4007", "4008",
                "405", "406", "407",
                "605", "607",
                "806", "807",
                "1007", "Partner", "Ranch", "Rifter",
                "Bipper", "Expert Tepee", "iOn"
            ),
            "Porsche" to listOf(
                "718 Boxster", "718 Cayman", "911", "Cayenne", "Macan",
                "Panamera", "Taycan", "Taycan Cross Turismo"
            ),
            "Ram" to listOf("1500", "2500", "3500", "ProMaster"),
            "Renault" to listOf(
                "Arkana", "Austral", "Captur", "Clio", "Espace", "Fluence", "Grand Scenic",
                "Kadjar", "Kangoo", "Koleos", "Laguna", "Master", "Megane", "Modus",
                "Scenic", "Symbol", "Talisman", "Trafic", "Twingo", "Zoe"
            ),
            "Rolls-Royce" to listOf("Cullinan", "Dawn", "Ghost", "Phantom", "Silver Shadow", "Spectre", "Wraith"),
            "SEAT" to listOf(
                // Actuales
                "Arona", "Ateca", "Ibiza", "Leon", "Tarraco",
                // Históricos
                "Alhambra", "Altea", "Altea XL", "Cordoba", "Exeo",
                "Fura", "Inca", "Malaga", "Marbella", "Mii",
                "Panda", "Ronda", "Terra", "Toledo",
                "600", "850", "1200", "1430", "124", "127", "128", "131", "132", "133"
            ),
            "Škoda" to listOf("Citigo", "Fabia", "Kamiq", "Karoq", "Kodiaq", "Octavia", "Rapid", "Scala", "Superb"),
            "Smart" to listOf("#1", "#3", "EQ Forfour", "EQ Fortwo", "Forfour", "Fortwo"),
            "Subaru" to listOf("BRZ", "Forester", "Impreza", "Legacy", "Outback", "WRX", "XV"),
            "Suzuki" to listOf(
                "Address", "Baleno", "Burgman", "GSR 750", "GSX-R 600", "GSX-R 750", "GSX-R 1000",
                "GSX-S 750", "GSX-S 1000", "Ignis", "Jimny", "SV 650", "Swift", "V-Strom 650",
                "V-Strom 1000", "Vitara"
            ),
            "Tesla" to listOf("Cybertruck", "Model 3", "Model S", "Model X", "Model Y", "Roadster"),
            "Toyota" to listOf(
                // Actuales
                "Aygo X", "C-HR", "Camry", "Corolla", "GR86", "GR Supra", "GR Yaris",
                "Hilux", "Land Cruiser", "Prius", "Proace", "Proace City", "RAV4",
                "Yaris", "Yaris Cross", "bZ4X",
                // Recientes descatalogados
                "Auris", "Avensis", "Aygo", "Urban Cruiser", "Verso",
                // Históricos
                "4Runner", "Carina", "Carina E", "Celica", "Corolla Verso",
                "FJ Cruiser", "FJ40", "GT86", "IQ",
                "Land Cruiser 70", "Land Cruiser 80", "Land Cruiser 90", "Land Cruiser 100",
                "Land Cruiser 120", "Land Cruiser 150", "Land Cruiser 200",
                "MR2", "Paseo", "Picnic", "Previa", "Prius+", "Prius v",
                "Sequoia", "Starlet", "Supra", "Tacoma", "Tercel",
                "Tundra", "Venza", "Yaris Verso"
            ),
            "Triumph" to listOf(
                "Bonneville T100", "Bonneville T120", "Rocket 3", "Speed Triple",
                "Scrambler", "Tiger 660", "Tiger 900", "Tiger 1200", "Trident 660"
            ),
            "Volkswagen" to listOf(
                // Actuales
                "Arteon", "Caddy", "California", "Caravelle", "Crafter",
                "Golf", "ID.3", "ID.4", "ID.5", "ID.7", "Multivan",
                "Passat", "Polo", "T-Cross", "T-Roc", "Taigo", "Tiguan",
                "Touareg", "Touran", "Transporter", "Up!",
                // Históricos
                "Bora", "Corrado", "Derby", "Eos", "Fox",
                "Golf Plus", "Golf Sportsvan", "Golf Variant",
                "Jetta", "Lupo", "Phaeton", "Scirocco",
                "Sharan", "Vento",
                "Beetle", "New Beetle",
                "LT", "LT 28", "LT 35",
                "181", "411", "412", "1200", "1300", "1500", "1600"
            ),
            "Volvo" to listOf("C30", "C40", "EX30", "EX90", "S40", "S60", "S80", "S90", "V40", "V60", "V90", "XC40", "XC60", "XC90"),
            "Yamaha" to listOf(
                "FZ6", "FZ8", "MT-03", "MT-07", "MT-09", "MT-10",
                "Nmax", "R1", "R3", "R6", "TMAX", "Tracer 700", "Tracer 900",
                "Ténéré 700", "XSR 700", "XSR 900", "XMAX", "YZF-R"
            ),
            "Ducati" to listOf(
                "Diavel", "Hypermotard", "Monster", "Multistrada", "Panigale V2",
                "Panigale V4", "Scrambler", "Streetfighter", "Supersport"
            ),
            "Harley-Davidson" to listOf(
                "Fat Bob", "Fat Boy", "Iron 883", "Iron 1200", "Nightster",
                "Pan America", "Road Glide", "Road King", "Softail", "Sportster",
                "Street Bob", "Street Glide"
            ),
            "BMW Motorrad" to listOf(
                "F 750 GS", "F 850 GS", "F 900 R", "F 900 XR",
                "G 310 GS", "G 310 R", "R 1250 GS", "R 1250 RT",
                "R nineT", "S 1000 RR", "S 1000 XR"
            ),
            "Vespa" to listOf("GTS 125", "GTS 300", "Primavera 125", "Sprint 125"),
            "Piaggio" to listOf("Beverly 300", "Beverly 400", "Liberty", "MP3", "Medley"),
            "BYD" to listOf("Atto 3", "Dolphin", "Han", "Seal", "Song Plus", "Tang"),
            "Dacia" to listOf("Duster", "Jogger", "Logan", "Sandero", "Spring", "Bigster"),
            "Aprilia" to listOf(
                "RS 125", "RS 660", "Shiver 900", "Tuono V4",
                "SR 125", "SR 160", "Dorsoduro"
            ),
            "Royal Enfield" to listOf(
                "Bullet 350", "Classic 350", "Continental GT 650",
                "Himalayan", "Hunter 350", "Interceptor 650", "Meteor 350", "Scram 411"
            ),
            "Keeway" to listOf(
                "Arsen 125", "Cityblade 125", "Cityblade 300", "Flash 125",
                "K-Light 125", "K-Light 202", "Laser 150", "RKS 125", "RKS 300",
                "Superlight 125", "Texas 125", "TX 125", "V302C"
            ),
            "Kymco" to listOf(
                // Scooters urbanos
                "Agility 50", "Agility 125", "Agility 150", "Agility 300",
                "Agility City 125", "Agility RS 125",
                "CityCom 300", "CityZone 125",
                "Filly 50", "Filly 125",
                "Grand Dink 125", "Grand Dink 250", "Grand Dink 300",
                "Like 50", "Like 125", "Like 150", "Like 200i", "Like S 125",
                "Maxi 300",
                "Movie 125", "Movie 150", "Movie XL 125", "Movie XL 150",
                "New Dink 125", "New Dink 150",
                "People 50", "People 125", "People 150", "People 200", "People 250", "People 300",
                "People GT 200", "People GT 300", "People S 125", "People S 200", "People S 250", "People S 300",
                "Vitality 50", "Vitality 125",
                // Scooters gran turismo
                "AK 550",
                "Downtown 125", "Downtown 300", "Downtown 350",
                "Superdink 125", "Superdink 150", "Superdink 350",
                "Xciting 400", "Xciting 500", "Xciting R 500", "Xciting S 400",
                // Naked / Sport
                "CK1 125", "CK1 150",
                "K-Pipe 125",
                "Quannon 125", "Quannon 150",
                "Pulsar 125",
                "Zing 125",
                // Trail / Enduro / Adventure
                "MXU 150", "MXU 300", "MXU 400", "MXU 450", "MXU 500", "MXU 550",
                "MXU 700", "MXU 700i",
                "UXV 450", "UXV 500", "UXV 700",
                "Maxxer 50", "Maxxer 90", "Maxxer 300", "Maxxer 400", "Maxxer 450",
                // Eléctricos
                "Ionex S", "Ionex Sport", "F9"
            ),
            "SYM" to listOf(
                "Cruisym 125", "Cruisym 300", "Fiddle 125",
                "Joymax Z 125", "Joymax Z 300", "Joyride 125",
                "NH-T 125", "Orbit II 125", "Symphony 125", "VS 125"
            ),
            "Lifan" to listOf(
                "KP 150", "KP 200", "KPM 150", "KPR 150", "KPR 200",
                "LF 125", "LF 150", "LF 200", "V16"
            ),
            "Voge" to listOf(
                "300 AC", "300 DS", "300 R", "300 Rally", "500 AC",
                "500 DS", "500 R", "525 DSX", "650 DS", "650 DSX"
            ),
            "Zontes" to listOf(
                "125 G1", "125 R", "125 U", "125 X",
                "310 R", "310 T", "310 X",
                "350 T", "350 X", "GK 125"
            ),
            "Rieju" to listOf(
                "MRT 50", "MRT 125", "MRT 300",
                "RS3 50", "RS3 125", "Nuuk 50", "Nuuk 125", "Tango 125"
            ),
            "Orcal" to listOf(
                "Astor 125", "Cafe Racer 125", "FK1 125", "Scrambler 125"
            )
        )

        val TireSizes = listOf(
            // Turismos y SUV (formato P/mm-R)
            "155/65R13", "165/65R13", "175/65R13", "185/65R13",
            "155/70R13", "165/70R13", "175/70R13", "185/70R13",
            "175/65R14", "185/60R14", "185/65R14", "195/60R14", "195/65R14", "205/60R14",
            "175/65R15", "185/55R15", "185/60R15", "185/65R15",
            "195/50R15", "195/55R15", "195/60R15", "195/65R15",
            "205/50R15", "205/55R15", "205/60R15", "205/65R15",
            "215/60R15", "215/65R15",
            "185/55R16", "195/45R16", "195/50R16", "195/55R16",
            "205/45R16", "205/50R16", "205/55R16", "205/60R16", "205/65R16",
            "215/45R16", "215/55R16", "215/60R16", "215/65R16",
            "225/50R16", "225/55R16", "225/60R16", "225/65R16",
            "235/60R16", "235/65R16",
            "195/45R17", "205/40R17", "205/45R17", "205/50R17", "205/55R17",
            "215/40R17", "215/45R17", "215/50R17", "215/55R17", "215/60R17", "215/65R17",
            "225/40R17", "225/45R17", "225/50R17", "225/55R17", "225/60R17", "225/65R17",
            "235/40R17", "235/45R17", "235/50R17", "235/55R17", "235/60R17", "235/65R17",
            "245/40R17", "245/45R17", "245/65R17",
            "255/40R17", "255/45R17", "255/65R17",
            "265/65R17", "275/65R17", "285/65R17",
            "205/40R18", "215/35R18", "215/40R18", "215/45R18", "215/50R18", "215/55R18",
            "225/35R18", "225/40R18", "225/45R18", "225/50R18", "225/55R18", "225/60R18",
            "235/40R18", "235/45R18", "235/50R18", "235/55R18", "235/60R18", "235/65R18",
            "245/35R18", "245/40R18", "245/45R18", "245/50R18", "245/60R18", "245/65R18",
            "255/35R18", "255/40R18", "255/45R18", "255/55R18", "255/60R18",
            "265/35R18", "265/40R18", "265/60R18", "265/65R18",
            "275/35R18", "275/40R18", "275/45R18", "275/65R18",
            "285/40R18", "285/45R18", "285/60R18",
            "225/35R19", "225/40R19", "225/45R19", "225/55R19",
            "235/35R19", "235/40R19", "235/45R19", "235/50R19", "235/55R19",
            "245/35R19", "245/40R19", "245/45R19", "245/50R19", "245/55R19",
            "255/35R19", "255/40R19", "255/45R19", "255/50R19", "255/55R19",
            "265/30R19", "265/35R19", "265/40R19", "265/50R19",
            "275/30R19", "275/35R19", "275/40R19", "275/45R19",
            "285/30R19", "285/35R19", "285/40R19", "285/45R19",
            "305/30R19", "305/35R19",
            "225/35R20", "235/30R20", "235/35R20", "245/30R20", "245/35R20", "245/40R20",
            "255/30R20", "255/35R20", "255/40R20", "255/45R20", "255/50R20", "255/55R20",
            "265/30R20", "265/35R20", "265/45R20", "265/50R20",
            "275/30R20", "275/35R20", "275/40R20", "275/45R20", "275/55R20",
            "285/30R20", "285/35R20", "285/40R20", "285/50R20",
            "295/30R20", "295/35R20", "295/40R20",
            "305/30R20", "305/35R20",
            "315/30R20", "315/35R20",
            // Motos (formato mm/mm-R)
            "80/90-17", "90/80-17", "90/90-17", "100/80-17", "100/90-17",
            "110/70-17", "110/80-17", "110/90-17",
            "120/60-17", "120/70-17", "120/80-17", "120/90-17",
            "130/70-17", "130/80-17", "130/90-17",
            "140/70-17", "140/80-17",
            "150/60-17", "150/70-17", "150/80-17",
            "160/60-17", "160/70-17",
            "170/60-17",
            "180/55-17",
            "190/50-17", "190/55-17",
            "200/55-17",
            "110/70-18", "120/60-18", "120/70-18",
            "130/70-18",
            "140/80-18",
            "150/70-18",
            "80/100-21", "90/90-21",
            "120/70-19", "130/80-19",
            "150/80-16", "130/80-17"
        )
    }
}